import { Transition } from '@uirouter/react';
import {
  customerCreditsList,
  marketplaceProviderOfferingsList,
  projectsRetrieve,
} from 'waldur-js-client';

import { fetchResultCount } from '@/core/api';
import { getCustomer } from '@/customer/utils';
import { router } from '@/router';
import store from '@/store/store';
import { setCurrentCustomer, setCurrentProject } from '@/workspace/actions';

export function loadProject(transition: Transition) {
  if (!transition.params().uuid) {
    return router.stateService.go('errorPage.notFound');
  }

  async function loadData() {
    try {
      const includeTerminated =
        transition.params().include_terminated === 'true';
      const project = await projectsRetrieve({
        path: { uuid: transition.params().uuid },
        query: includeTerminated ? ({ include_terminated: true } as any) : {},
      });

      const existingCustomer = store.getState().workspace.customer;
      const isSameCustomer =
        existingCustomer?.uuid === project.data.customer_uuid;

      const [customer, credit, myOfferingsResult] = await Promise.all([
        getCustomer(project.data.customer_uuid, [
          'url',
          'uuid',
          'created',
          'display_name',
          'image',
          'blocked',
          'archived',
          'projects_count',
          'name',
          'native_name',
          'abbreviation',
          'customer_credit',
          'is_service_provider',
          'user_email_patterns',
          'user_affiliations',
          'user_identity_sources',
        ]),
        isSameCustomer && existingCustomer?.credit !== undefined
          ? Promise.resolve(existingCustomer.credit)
          : customerCreditsList({
              query: { customer_uuid: project.data.customer_uuid },
            })
              .then((r) => r.data[0])
              .catch(() => undefined),
        isSameCustomer && existingCustomer?.has_my_offerings !== undefined
          ? Promise.resolve(existingCustomer.has_my_offerings)
          : marketplaceProviderOfferingsList({
              query: {
                customer_uuid: project.data.customer_uuid,
                billable: false,
                page_size: 1,
              },
            })
              .then((r) => fetchResultCount(r) > 0)
              .catch(() => false),
      ]);

      Object.assign(customer, {
        credit,
        has_my_offerings:
          typeof myOfferingsResult === 'boolean'
            ? myOfferingsResult
            : false,
      });

      store.dispatch(setCurrentCustomer(customer));
      store.dispatch(setCurrentProject(project.data));
    } catch (error) {
      if (error.response?.status === 404) {
        router.stateService.go('errorPage.notFound');
      }
    }
  }
  return loadData();
}
